
import React from 'react';
import { ConditionsTab } from '../components/organisms/node-settings/ConditionsTab';
import { EmailTemplateTab } from '../components/organisms/node-settings/EmailTemplateTab';
import { FormBuilderTab } from '../components/organisms/node-settings/FormBuilderTab';
import { AssignmentsTab } from '../components/organisms/node-settings/AssignmentsTab';
import { TimerTab } from '../components/organisms/node-settings/TimerTab';
import { MessageSignalTab } from '../components/organisms/node-settings/MessageSignalTab';
import { DatabaseTab } from '../components/organisms/node-settings/DatabaseTab';
import { CallActivityTab } from '../components/organisms/node-settings/CallActivityTab';
import { HttpTab } from '../components/organisms/node-settings/HttpTab';
import { ScriptTab } from '../components/organisms/node-settings/ScriptTab';
import { LLMConfigTab } from '../components/organisms/node-settings/LLMConfigTab';
import { UserTaskExtensionTab } from '../components/organisms/node-settings/UserTaskExtensionTab';
import { SmsTab } from '../components/organisms/node-settings/SmsTab';
import { ExtractionTab } from '../components/organisms/node-settings/ExtractionTab';
import { McpTab } from '../components/organisms/node-settings/McpTab';
import { DecisionTab } from '../components/organisms/node-settings/DecisionTab';
import { StartProcessTab } from '../components/organisms/node-settings/StartProcessTab';

// Default mapping of string keys to React Components
export const defaultComponentRegistry: Record<string, React.ComponentType<any>> = {
    'ConditionsTab': ConditionsTab,
    'RoutingTab': ConditionsTab, // Alias
    'EmailTemplateTab': EmailTemplateTab,
    'SmsTab': SmsTab,
    'FormBuilderTab': FormBuilderTab,
    'AssignmentsTab': AssignmentsTab,
    'TimerTab': TimerTab,
    'ScriptTab': ScriptTab,
    'MessageTab': (props: any) => React.createElement(MessageSignalTab, { ...props, type: "message" }),
    'MessageThrowTab': (props: any) => React.createElement(MessageSignalTab, { ...props, type: "message", isThrowing: true }),
    'SignalTab': (props: any) => React.createElement(MessageSignalTab, { ...props, type: "signal" }),
    'SignalThrowTab': (props: any) => React.createElement(MessageSignalTab, { ...props, type: "signal", isThrowing: true }),
    'DatabaseTab': DatabaseTab,
    'CallActivityTab': CallActivityTab,
    'RestConfigTab': HttpTab,
    'LLMConfigTab': LLMConfigTab,
    'UserTaskExtensionTab': UserTaskExtensionTab,
    'ExtractionTab': ExtractionTab,
    'McpConfigTab': McpTab,
    'DecisionConfigTab': DecisionTab,
    'StartProcessTab': StartProcessTab
};
